module.exports = __webpack_public_path__ + "static/about-lg-204f7958067e30bbd34c1656eb4c52f0.jpg";